<script lang="ts" setup>
import { useGlobalStore } from '@/stores'

const lists = ref([
  {
    mainTitle: '恆隆行首頁',
    data: [
      {
        title: '首頁',
        link: '/'
      },
      {
        title: '會員活動',
        link: '/events'
      }
    ]
  },
  {
    mainTitle: '找生活',
    data: [
      {
        title: 'hengstyle Life',
        link: '/hence'
      },
      {
        title: 'zonezone 概念店',
        link: '/zonezone'
      }
    ]
  },
  {
    mainTitle: '找服務',
    data: [
      {
        title: '產品支援',
        link: '/services'
      },
      {
        title: '保固註冊',
        link: '/services/warranty'
      },
      {
        title: '產品維修',
        link: '/services/repair'
      },
      {
        title: '到府教學服務',
        link: '/services/inhome'
      },
      {
        title: '深層清潔',
        link: '/services/cleaning'
      }
    ]
  },
  {
    mainTitle: '關於恆隆行',
    data: [
      {
        title: '品牌故事',
        link: '/brand-story'
      },
      {
        title: '代理品牌',
        link: '/brands'
      },
      {
        title: '最新消息',
        link: '/news'
      },
      {
        title: '永續生活',
        link: '/sustainability'
      },
      {
        title: '人才發展',
        link: '/talent-development'
      }
    ]
  },
  {
    mainTitle: '找好物',
    data: [
      {
        title: '線上購物',
        link: 'https://shop.hengstyle.com/'
      },
      {
        title: '選品服務',
        link: '/services/select'
      }
    ]
  },
  {
    mainTitle: '會員計劃',
    data: [
      {
        title: '生活有亮點計劃',
        link: '/membership'
      }
    ]
  }
])

const globalStore = useGlobalStore()
globalStore.setBreadcrumbs([{ title: '網站地圖', isActive: true, url: '/sitemap' }])

useSeoMeta({
  title: `網站地圖｜${import.meta.env.VITE_WEBSITE_TITLE}`,
  ogTitle: `網站地圖｜${import.meta.env.VITE_WEBSITE_TITLE}`,
  // description: globalStore.seoDescriptions.sitemap,
  // ogDescription: globalStore.seoDescriptions.sitemap
  // ogImage: faq.value.seo?.og_image?.link,
  // keywords: faq.value.seo?.meta_keywords.join(',')
})

useHead({
  link: [
    {
      rel: 'canonical',
      href: `${import.meta.env.VITE_DOMAIN}/sitemap`
    }
  ]
})

useJsonld({
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首頁',
          item: import.meta.env.VITE_DOMAIN
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: '網站地圖',
          item: `${import.meta.env.VITE_DOMAIN}/sitemap`
        }
      ]
    }
  ]
})
</script>

<template>
  <section class="sitemap">
    <div class="sitemap__inner">
      <Intro class="sitemap__intro display80 align-left" subtitle="sitemap" :data="{
        title: '網站地圖'
      }" />
      <ul class="sitemap__lists">
        <li v-for="(item, index) in lists" :key="index">
          <div class="sitemap__lists__item">
            <div class="sitemap__lists__mainTitle">{{ item.mainTitle }}</div>
            <div class="sitemap__lists__bottom">
              <nuxt-link :to="data.link" v-for="(data, dataIndex) in item.data" :title="data.title" :key="dataIndex">
                {{ data.title }}
              </nuxt-link>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.sitemap {
  @include grid;

  @include max-media(990) {
    @include grid(4, 24);
  }

  &__inner {
    grid-column: 3 / span 8;

    @include max-media(990) {
      grid-column: 1 / span 4;
    }
  }

  &__intro {
    margin-bottom: toRem(60);
  }

  &__lists {
    display: flex;
    flex-wrap: wrap;
    margin-left: toRem(-24);
    margin-right: toRem(-24);

    @include max-media(480) {
      margin-left: toRem(-16);
      margin-right: toRem(-16);
    }

    li {
      width: 33.333%;
      padding-left: toRem(24);
      padding-right: toRem(24);
      margin-bottom: toRem(32);

      @include max-media(480) {
        width: 50%;
        padding-left: toRem(16);
        padding-right: toRem(16);
      }
    }

    &__mainTitle {
      font-size: toRem(22);
      color: $color-gray-2;
      font-weight: 500;
      line-height: 1.3;
      border-bottom: 2px solid $color-gray-line;
      padding-bottom: toRem(12);
      margin-bottom: toRem(12);

      @include max-media(480) {
        font-size: toRem(20);
      }
    }

    &__bottom {
      a {
        display: block;
        margin-bottom: toRem(16);
        font-size: toRem(16);
        font-weight: 400;
        line-height: 1.45;
        color: $color-black-1;
        transition: all 0.5s cubic-bezier(0.87, 0, 0.13, 1);

        &:hover {
          color: $color-brand-4_1;
        }
      }
    }
  }
}
</style>
